import { render, staticRenderFns } from "./ServiceDashboardTutorCardHeaderAbstract.vue?vue&type=template&id=8d847de8&scoped=true&"
import script from "./ServiceDashboardTutorCardHeaderAbstract.vue?vue&type=script&lang=js&"
export * from "./ServiceDashboardTutorCardHeaderAbstract.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDashboardTutorCardHeaderAbstract.vue?vue&type=style&index=0&id=8d847de8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d847de8",
  null
  
)

export default component.exports